import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-search-form__overlay",
  "data-qa": "navbar-search-form"
}
const _hoisted_2 = ["action"]
const _hoisted_3 = { class: "gfu-search-form-fields__field gfu-field" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "gfu-search-form-results__no-results",
  "data-qa": "search-form:EmptyState"
}
const _hoisted_8 = {
  key: 1,
  class: "gfu-search-form-results__group",
  "data-qa": "search-form:Results"
}
const _hoisted_9 = { class: "gfu-search-form-results__heading" }
const _hoisted_10 = {
  key: 0,
  class: "gfu-search-form-results__more"
}
const _hoisted_11 = {
  key: 2,
  class: "gfu-search-form-results__group",
  "data-qa": "search-form:Results"
}
const _hoisted_12 = { class: "gfu-search-form-results__heading" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_creators_line = _resolveComponent("creators-line")
  const _component_search_form_item = _resolveComponent("search-form-item")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-search-form', {'is-visible': $options.overlayIsVisible, 'gfu-search-form--with-results': _ctx.isProcessing || $options.hasResults }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        ref: "form",
        class: _normalizeClass(["gfu-search-form__fields gfu-search-form-fields", {'gfu-search-form-fields--with-close-button': $options.isFocused, 'gfu-search-form-fields--focused': $options.isFocused}]),
        method: "get",
        action: $options.searchAction
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "gfu-search-form-fields__search-button gfu-btn",
            "aria-label": _ctx.Resources.Layout.SearchFormSearchButtonLabel,
            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onInputEnterKeyPress && $options.onInputEnterKeyPress(...args)), ["stop","prevent"])),
            "data-qa": "search-form-button:Search"
          }, [
            _createVNode(_component_base_icon, { name: "search" })
          ], 8 /* PROPS */, _hoisted_4),
          _createElementVNode("input", {
            ref: "input",
            value: $data.formModel.term,
            placeholder: _ctx.Resources.Layout.SearchFormPlaceholder,
            maxlength: 80,
            type: "text",
            class: "gfu-field__input gfu-field__input--soft gfu-search-form-fields__input",
            name: "term",
            autocomplete: "off",
            onInput: _cache[1] || (_cache[1] = (...args) => ($options.handleInput && $options.handleInput(...args))),
            onKeydown: [
              _cache[2] || (_cache[2] = _withKeys(_withModifiers((...args) => ($options.onInputEnterKeyPress && $options.onInputEnterKeyPress(...args)), ["prevent","stop"]), ["enter"])),
              _cache[3] || (_cache[3] = _withKeys((...args) => ($options.abortSearch && $options.abortSearch(...args)), ["esc"]))
            ],
            onFocus: _cache[4] || (_cache[4] = (...args) => ($options.onInputFocus && $options.onInputFocus(...args))),
            onBlur: _cache[5] || (_cache[5] = (...args) => ($options.onInputBlur && $options.onInputBlur(...args))),
            "data-qa": "search-form:Input"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
          _createElementVNode("button", {
            class: "gfu-search-form-fields__close-button gfu-btn",
            onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.abortSearch && $options.abortSearch(...args)), ["stop","prevent"]))
          }, [
            _createVNode(_component_base_icon, { name: "times" })
          ])
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(["gfu-search-form__results gfu-search-form-results", {'gfu-search-form__results--visible': _ctx.isProcessing || $options.hasResults}])
      }, [
        _createVNode(_component_progress_overlay, {
          visible: _ctx.isProcessing,
          small: true
        }, null, 8 /* PROPS */, ["visible"]),
        ($options.hasResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!$data.projects.totalItemCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.Resources.Layout.SearchFormEmptyState), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($data.projects.totalItemCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.Resources.Layout.SearchFormResultsProjectsCountLabel) + " ", 1 /* TEXT */),
                      _createElementVNode("strong", null, _toDisplayString($data.projects.totalItemCount), 1 /* TEXT */)
                    ]),
                    _createCommentVNode(" #32411 subtitle here "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.projects.pagedItems, (project) => {
                      return (_openBlock(), _createBlock(_component_search_form_item, {
                        key: `project-${project.projectID}`,
                        url: project.projectPageUrl,
                        title: project.name,
                        subtitle: project.creator.name,
                        "thumb-image-url": project.thumbImageUrl,
                        class: "_mb-2",
                        "data-qa": `search-form-results-projects:${project.projectID}`
                      }, {
                        subtitle: _withCtx(() => [
                          _createVNode(_component_creators_line, {
                            creator: project.creator,
                            "co-creators": project.coCreators,
                            "hide-prefix": ""
                          }, null, 8 /* PROPS */, ["creator", "co-creators"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["url", "title", "subtitle", "thumb-image-url", "data-qa"]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    ($data.projects.totalPageCount > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("a", {
                            href: "",
                            class: "gfu-link gfu-link--accent",
                            onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => ($options.submitForm && $options.submitForm(...args)), ["prevent"]))
                          }, _toDisplayString(_ctx.Resources.Layout.SearchFormViewMoreLink), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.creators && $data.creators.totalItemCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.Resources.Layout.SearchFormResultsCreatorsCountLabel) + " ", 1 /* TEXT */),
                      _createElementVNode("strong", null, _toDisplayString($data.creators.totalItemCount), 1 /* TEXT */)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.creators.pagedItems, (creator) => {
                      return (_openBlock(), _createBlock(_component_search_form_item, {
                        key: `creator-${creator.creatorID}`,
                        url: creator.creatorPageUrl,
                        title: creator.name,
                        "thumb-image-url": creator.thumbImageUrl,
                        class: "_mb-2",
                        "data-qa": `search-form-results:${creator.name}`
                      }, null, 8 /* PROPS */, ["url", "title", "thumb-image-url", "data-qa"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ], 2 /* CLASS */))
}